module.exports = __webpack_public_path__ + "img/youtube.85681ca5.png";